import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  icon?: React.ReactNode;
  total: number;
  contacted: number;
  available: number;
  onActionClick?: () => void;
}

const OrganizationStatsCard: React.FC<Props> = ({
  icon,
  total,
  contacted,
  available,
  onActionClick,
}) => {
  const { t } = useTranslation();

  return (
    <div className="w-full bg-white bg-gradient-to-br from-yellow-50 via-white to-yellow-100 border-2 border-yellow-200 p-6 rounded-xl shadow-lg flex flex-col gap-6 transition-all duration-300">
      {/* Header */}
      <div className="flex items-center gap-4">
        <div className="flex items-center justify-center w-12 h-12 bg-yellow-100 text-yellow-600 rounded-full shadow-inner">
          {icon}
        </div>
        <h3 className="text-base text-slate-700 font-semibold">
          {t('admin.organizations_card_title')}
        </h3>
      </div>

      {/* Métricas */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 px-2 text-center">
        <div className="flex flex-col">
          <span className="text-sm text-gray-500">{t('admin.total')}</span>
          <span className="text-2xl font-bold text-slate-800">{total}</span>
        </div>
        <div className="flex flex-col">
          <span className="text-sm text-gray-500">{t('admin.contacted')}</span>
          <span className="text-2xl font-bold text-gray-400">{contacted}</span>
        </div>
        <div className="flex flex-col">
          <span className="text-sm text-gray-500">{t('admin.available')}</span>
          <span className="text-2xl font-bold text-green-600">{available}</span>
        </div>
      </div>

      {/* Botón */}
      <div className="pt-2">
        <button
          onClick={onActionClick}
          className="w-full bg-gradient-to-r from-yellow-400 to-yellow-500 text-slate-900 font-bold py-2 px-4 rounded-xl shadow hover:from-yellow-500 hover:to-yellow-600 transition-all duration-200"
        >
          {t('admin.spread_democracy')}
        </button>
      </div>
    </div>
  );
};

export default OrganizationStatsCard;
